/**
 * MapUnsavedDialog — Confirmation dialog when user tries to close map with unsaved changes.
 * [COLLATERAL MAP] Added 2026-07-14
 * [MAP v9] BUG-D FIX 2026-07-15: Added "Save and Close" as primary action.
 *   3-button layout: [ບັນທຶກ ແລ້ວ ປິດ] [ຍົກເລີກ ແລ້ວ ປິດ] [ກັບໄປ]
 */

import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./ui/alert-dialog";
import { AlertTriangle, Save } from "lucide-react";

interface MapUnsavedDialogProps {
  open: boolean;
  onConfirmDiscard: () => void;
  onCancel: () => void;
  /** BUG-D FIX: primary action — save then close */
  onSaveAndClose?: () => void;
  description?: string;
  saveLabel?: string;
  discardLabel?: string;
  cancelLabel?: string;
}

export function MapUnsavedDialog({
  open,
  onConfirmDiscard,
  onCancel,
  onSaveAndClose,
  description = 'ທ່ານໄດ້ແຕ້ມຂອບເຂດໃໝ່ ແຕ່ຍັງບໍ່ໄດ້ກົດ "ບັນທຶກ" — ຕ້ອງການດຳເນີນການໃດ?',
  saveLabel = 'ບັນທຶກ ແລ້ວ ປິດ',
  discardLabel = 'ຍົກເລີກ ແລ້ວ ປິດ',
  cancelLabel = 'ກັບໄປ',
}: MapUnsavedDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={(v) => !v && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            ມີການປ່ຽນແປງທີ່ຍັງບໍ່ໄດ້ບັນທຶກ
          </AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col gap-2 sm:flex-col">
          {/* Primary action: Save and Close */}
          {onSaveAndClose && (
            <AlertDialogAction
              onClick={onSaveAndClose}
              className="bg-blue-600 hover:bg-blue-700 text-white w-full sm:w-auto"
            >
              <Save className="h-4 w-4 mr-2" />
              {saveLabel}
            </AlertDialogAction>
          )}
          {/* Destructive: discard and close */}
          <AlertDialogAction
            onClick={onConfirmDiscard}
            className="bg-red-600 hover:bg-red-700 text-white w-full sm:w-auto"
          >
            {discardLabel}
          </AlertDialogAction>
          {/* Cancel: go back to drawing */}
          <AlertDialogCancel onClick={onCancel} className="w-full sm:w-auto">
            {cancelLabel}
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
